
var jlStripe = {
  load:function(hashKey,plan,amount,renew=false){
    this.hashKey = hashKey;
    this.plan = plan;
 
    this.amount = (amount || 129)*100;
    this.renew=renew;

    this.stripe = Stripe('pk_live_r8vJ8gmxgfuDrCEcWVJpLeB6');
    this.elements = this.stripe.elements();
    this.form = document.getElementById('payment-form');

    this.card = this.elements.create("card",{
        style: {
          base: {

          fontWeight: 500,
          padding:15,
          fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
          fontSize: '18px',
          fontSmoothing: 'antialiased',

          ':-webkit-autofill': {
            color: '#000',
          },
          '::placeholder': {
            color: '#000',
          },
        }
      }
    });
    this.card.mount("#card-element");
    this.events();
  },
  events:function(){
    var self = this;
    this.card.on('change', ({error}) => {
      let displayError = document.getElementById('card-errors');
      if (error) {
        self.form.errorMessage(error.message);

      } else {
        displayError.textContent = '';
      }
    });


    this.form.addEventListener('submit', function(ev) {
    //  ev.preventDefault();
      // If the client secret was rendered server-side as a data-secret attribute
      // on the <form> element, you can retrieve it here by calling `form.dataset.secret`

    });
  },
  setPromoCode:function(e=false){
    if(e){
      e.preventDefault();
    }

    this.updatePromoCode();

  },
  updatePromoCode:async function(){
    var self = this;
    return new Promise((resolve,reject)=>{
      self.promoCode = document.getElementById("promoCode").value;
      jlLoader.show("Verifying Promo Code");
      fetch(JLAJAX.url+"promoCode",{
        method:"POST",
        headers:{
          'Accept':'application/json',
          'Content-Type':'application/json'
        },
        body:JSON.stringify({
            'id':hh2020Login.userData.id,
            'token':hh2020Login.userData.token,
            'promoCode':this.promoCode,
            'plan':this.plan,
            'isRenewal':this.renew
        })
      }).then(res=>res.json())
      .then(data=>{
        jlLoader.hide();
        if(data.error){
          document.getElementById("ccInput").style.display = "block";

          self.form.errorMessage(data.message);

        }
        else{
          document.getElementById("checkoutPromoCode").style.display = "block";
          document.getElementById("checkoutPromoCode").innerHTML = "<div class='item'>"+data.description+"</div><div class='price'>-$"+data.discount+"</div>";
          document.getElementById("checkoutGrandTotalPrice").innerHTML = "$"+data.totalPrice;
          document.getElementById("planPrice").innerHTML = "$"+data.plan.price.toFixed(2);
          document.getElementById("planDescription").innerHTML = data.plan.name+"<br/><i><small>"+data.plan.description+"</small></i>";
          document.getElementById("checkoutGrandTotal").style.display = "block";

          if(parseFloat(data.totalPrice) <= 0){
            document.getElementById("ccInput").style.display = "none";
          }
          else{
            document.getElementById("ccInput").style.display = "block";
          }

          if(data.planID){
            self.plan = data.planID;
          }
          self.amount = parseFloat(data.totalPrice)*100;
        }
        resolve(true);
      });
    });
  },
  setForm:function(form){
    this.form = form;
  },
  createIntent:function(){
    var self = this;
    return new Promise((resolve,reject)=>{
      if(self.amount == 0){
        resolve(true);
      } else {
        fetch(JLAJAX.url+"paymentIntent",{
          method:"POST",
          headers:{
            'Accept':'application/json',
            'Content-Type':'application/json'
          },
          body:JSON.stringify({
              'id':hh2020Login.userData.id,
              'token':hh2020Login.userData.token,
              'amount':self.amount,
              'plan':self.plan
          })
        }).then(res=>res.json())
        .then(data=>{
          console.log(data);
          self.client_secret = data.client_secret;
          resolve(true);
        });
      }
    });

  },
  submit:async function(billingEmail){
    var self = this;

    if(document.getElementById("promoCode").value !== ""){
      await self.updatePromoCode();
    }

    jlLoader.show("Processing Payment");

    var billingEmail = document.getElementById("billingEmail").value;

    if(self.amount == 0){
      fetch(JLAJAX.url+"paymentConfirm/"+self.hashKey,{
        method:"POST",
        headers:{
          'Accept':'application/json',
          'Content-Type':'application/json'
        },
        body:JSON.stringify({
            'id':hh2020Login.userData.id,
            'token':hh2020Login.userData.token,
            'promoCode':self.promoCode,
            'amount':self.amount,
            'plan':self.plan,
            'hashKey':self.hashKey,
            'billingEmail':billingEmail,
            'isRenewal':self.renew

        })
      }).then(res=>res.json())
      .then(data=>{
        parent.location = JLAJAX.homeURL + "listing/"+self.hashKey+"/posted";

      });
    } else {
      await this.createIntent();
      self = this;


      self.stripe.confirmCardPayment(self.client_secret, {
        payment_method: {
          card: self.card,
          billing_details: {
            name: hh2020Login.userData.profile.name,
            email:hh2020Login.userData.profile.email,

          },


        },
        receipt_email:billingEmail
      }).then(function(result) {
        if (result.error) {

          jlLoader.hide();
          self.form.errorMessage(result.error.message);
        } else {
          // The payment has been processed!
          if (result.paymentIntent.status === 'succeeded') {
            var paymentIntentID = result.paymentIntent.id;

            fetch(JLAJAX.url+"paymentConfirm/"+self.hashKey,{
              method:"POST",
              headers:{
                'Accept':'application/json',
                'Content-Type':'application/json'
              },
              body:JSON.stringify({
                  'id':hh2020Login.userData.id,
                  'token':hh2020Login.userData.token,
                  'paymentIntentID':paymentIntentID,
                  'amount':result.paymentIntent.amount,
                  'promoCode':self.promoCode,
                  'hashKey':self.hashKey,
                  'renew':self.renew,
                  'billingEmail':billingEmail

              })
            }).then(res=>res.json())
            .then(data=>{
              //jlLoader.hide();
              parent.location = JLAJAX.homeURL + "listing/"+self.hashKey+"/posted";

            });


            // Show a success message to your customer
            // There's a risk of the customer closing the window before callback
            // execution. Set up a webhook or plugin to listen for the
            // payment_intent.succeeded event that handles any business critical
            // post-payment actions.
          }
        }
      });
    }
  }
}
  